/**
 * HOOK DE TRADUCCIÓN ROBUSTO Y SÓLIDO
 * Reemplaza el sistema anterior y garantiza traducciones siempre correctas
 */

import { useLanguage } from '@/context/LanguageContext';
import { getTranslation, TranslationNamespaces } from '@/context/languages/translationSystem';
import { Language } from '@/context/languages/languageData';

export const useRobustTranslation = () => {
  const { language } = useLanguage();
  
  // Función principal de traducción con namespace
  const tn = (namespace: keyof TranslationNamespaces, key: string): string => {
    return getTranslation(namespace, key, language);
  };
  
  // Funciones de conveniencia para cada namespace
  const nav = (key: string): string => tn('nav', key);
  const home = (key: string): string => tn('home', key);
  const howItWorks = (key: string): string => tn('howItWorks', key);
  const filters = (key: string): string => tn('filters', key);
  const common = (key: string): string => tn('common', key);
  
  return {
    // Función principal
    tn,
    
    // Funciones de conveniencia por namespace
    nav,
    home,
    howItWorks,
    filters,
    common,
    
    // Información del idioma actual
    currentLanguage: language
  };
};

export default useRobustTranslation;